var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-chip",class:{ focused: _vm.focused },style:({ background: _vm.colorHex })})
}
var staticRenderFns = []

export { render, staticRenderFns }